export default new class Preloader {
  constructor() {
    this.classBtnPreloader = '.loader';
    this.classPreloader = 'ld ld-ring ld-spin';
    this.timeout = 5000;

    const el = document.createElement('span');
    el.setAttribute('class', `${this.classPreloader}`);

    this.preloader = el;
    this.handleClick();
    this.stopHandle();
  }

  handleClick() {
    document.addEventListener('click', (e) => {
      if (!e.target.matches(`${this.classBtnPreloader}`)) return;

      this.btn = e.target;

      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.removeLoader();
      }, this.timeout);

      this.setLoader();
    });
  }

  setLoader() {
    this.btn.prepend(this.preloader);
  }

  removeLoader() {
    this.preloader.remove();
  }

  /**
   * service method for remove preloader
   */
  stopHandle() {
    document.addEventListener('click', (e) => {
      if (!e.target.matches('.stop')) return;

      this.removeLoader();
    });
  }
}();
